import { useEffect, useState } from 'react';
import { useGetSelectedLegalInsurance } from '../../../components/Shared';
import { useGlobalState } from '../../../state/persistence';
import { PartnerService, ProductSelectionInput, FlowService, PartnerProduct } from '../../../services';
import { useGetIntegratedPartnerIds } from '.';
import usePromise from 'react-promise-suspense';
import { ReferenceLabelTypeEnum } from '../../../types';

export default function useGetPartnerProducts(): PartnerProduct[] | undefined {
  const [partnerPackages, setPartnerPackages] = useState<PartnerProduct[] | undefined>(undefined);
  const { integratedPartnerIds } = useGetIntegratedPartnerIds();
  const legalInsurance = useGetSelectedLegalInsurance();
  const { appStore, question } = useGlobalState();

  let referenceLabelType = appStore.referenceLabelType ?? undefined;

  // use voucher ref label for union members as they should get a free product without insurance proof check
  if (question.hasUnionOptions) {
    referenceLabelType = ReferenceLabelTypeEnum.VOUCHER;
  }

  const filter = {
    legalInsurance: legalInsurance ?? undefined,
    referenceLabelType: referenceLabelType,
    ...(appStore.subscription ? { IS24: { subscription: appStore.subscription } } : {}),
  };

  const input: ProductSelectionInput = {
    type: FlowService.isCheckBusiness() ? 'business' : 'private',
    integratedPartnerIds: integratedPartnerIds,
    affiliatePartnerId: appStore.ref,
    filter: filter ? JSON.stringify(filter) : undefined,
  };

  const partnerProducts = usePromise(PartnerService.getPartnerPackages, [input]);
  useEffect(() => {
    if (!partnerPackages) {
      setPartnerPackages(partnerProducts);
    }
  }, [partnerProducts, partnerPackages]);

  return partnerPackages;
}
